export default __webpack_public_path__ + "static/media/roboto-v20-latin-700italic.cdb52a1c.eot";